
<div class="page-layout simple fullwidth" fusePerfectScrollbar>
    <app-scrum-bread-bar></app-scrum-bread-bar>
    
  <!-- CONTENT -->
    <div class="content p-16 mat-white-bg">
  
      <app-datatable *ngIf="data" #child [parent] ="this"  
      (edit)="editRecord($event)" 
      (delete)="deleteRecord($event)" 
      (add)="addRecord()"
      (customeClick)="changeAccess($event, type)" (getPageWiseData)="getServerData($event)" (getFilteredData)="applyFilter($event)"
      (getSortedData)="getSortedData($event)">
      	
      </app-datatable>
  
    </div>
    <!-- / CONTENT -->
  
  </div>
  
  


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user.component.html